// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","citySection":"citySection-module--city-section--34UQd"};